import { PROXIED_ENVS } from "PFCore/utilities/routes";

import { mockDemandSupplyData } from "./mock_data_demand_supply";

export const fetchSkillsBarData = (
  accessToken: string,
  fullDomain: string,
  params: Record<string, string>
) => {
  const domain = window.location.hostname;
  return $.ajax({
    url: `${PF.config.insights_api_endpoint}/skills_bar`,
    method: "get",
    headers: {
      profindaapitoken: accessToken,
      account: fullDomain,
      ...(PROXIED_ENVS.includes(PF.config.environment ?? "") ? null : { sessionHost: PF.config.api_endpoint })
    },
    data: params
  }).then((res) => {
    // Mock data only for demo env to show more roles and been able to explain disparity [PF-10630]
    if (domain.includes("demo")) {
      return mockDemandSupplyData(res);
    }
    return res;
  });
};
